export const SAFETY_GUARD_BANNER_TEXT =
  "Parents and guardians may provide information in this chat. If you are under the age of 13, do not enter information here.";
